import { Table, type TableTrProps } from '@mantine/core';
import { useId } from 'react';

export function KeyedRow(props: TableTrProps) {
	const id = useId();
	return <Table.Tr key={id} {...props} />;
}
